import Cart from "../globals/cart";
import ColorPickerModal from "./color-picker-modal";

class ProductConfigure {
  constructor() {
    this.initDropdown(
      {
        btns: ".js-configure-selected",
        dds: ".js-configure-items",
        items: ".js-configure-item",
      },
      this.handleDropdownItemClick
    );
    this.initDropdown(
      {
        btns: ".js-dim-selected",
        dds: ".js-dim-items",
        items: ".js-dim-item",
      },
      this.handleDimClick
    );
    this.initDropdown(
      {
        btns: ".js-finisher-selected",
        dds: ".js-finisher-items",
        items: ".js-finisher-item",
      },
      this.handleFinisherClick
    );
    new ColorPickerModal();
    this.addToCart();
  }

  initDropdown = (classes, handler) => {
    const btns = document.querySelectorAll(classes.btns);
    const dds = document.querySelectorAll(classes.dds);
    const items = document.querySelectorAll(classes.items);
    if (btns.length == 0) {
      return;
    }
    btns.forEach((btn, index) => {
      btn.addEventListener("click", () => {
        dds.forEach((dd) => {
          if (dd != dds[index]) {
            dd.classList.remove("active");
          } else dd.classList.toggle("active");
        });
      });
    });
    items.forEach((item) => {
      item.addEventListener("click", () => {
        handler(item, classes);
      });
    });
  };

  handleDimClick = (item, classes) => {
    let dropdown = item.parentNode;
    let adjancedItems = dropdown.querySelectorAll(classes.items);
    let selected = item.parentNode.parentNode.querySelector(classes.btns);
    adjancedItems.forEach((i) => {
      if (i != item) {
        i.classList.remove("active");
      }
    });
    selected.innerText = item.innerText;
    if (item.getAttribute("data-diameter")) {
      selected.setAttribute(
        "data-diameter",
        item.getAttribute("data-diameter") ?? ""
      );
      selected.removeAttribute("data-width");
      selected.removeAttribute("data-length");
    } else {
      selected.removeAttribute("data-diameter");
      selected.setAttribute(
        "data-width",
        item.getAttribute("data-width") ?? ""
      );
      selected.setAttribute(
        "data-length",
        item.getAttribute("data-length") ?? ""
      );
    }
    item.classList.add("active");
    dropdown.classList.remove("active");
    this.fetchData();
  };

  handleDropdownItemClick = (item, classes) => {
    let dropdown = item.parentNode;
    let adjancedItems = dropdown.querySelectorAll(classes.items);
    let selected = item.parentNode.parentNode.querySelector(classes.btns);
    adjancedItems.forEach((i) => {
      if (i != item) {
        i.classList.remove("active");
      }
    });
    selected.innerText = item.innerText;
    if (item.classList.contains("duplicate-item")) {
      let parent = item.parentNode.parentNode.parentNode;
      let duplicates = document.querySelectorAll(".duplicate");
      duplicates.forEach((dup) => {
        if (dup != parent) {
          let dupSelected = dup.querySelector(classes.btns);
          let dupItems = dup.querySelectorAll(classes.items);
          dupItems.forEach((dupItem) => {
            if (
              dupItem.getAttribute("data-slug") ==
              item.getAttribute("data-slug")
            ) {
              dupSelected.setAttribute(
                "data-slug",
                dupItem.getAttribute("data-slug")
              );
              dupSelected.setAttribute(
                "data-id",
                dupItem.getAttribute("data-id")
              );
            }
          });
        }
      });
    }
    selected.setAttribute("data-slug", item.getAttribute("data-slug"));
    selected.setAttribute("data-id", item.getAttribute("data-id"));

    item.classList.add("active");
    dropdown.classList.remove("active");
    this.fetchData();
  };

  handleFinisherClick = (item, classes) => {
    let dropdown = item.parentNode;
    let adjancedItems = dropdown.querySelectorAll(classes.items);
    let selected = item.parentNode.parentNode.querySelector(classes.btns);
    adjancedItems.forEach((i) => {
      if (i != item) {
        i.classList.remove("active");
      }
    });
    selected.innerText = item.innerText;
    item.classList.add("active");
    dropdown.classList.remove("active");
    this.fetchData();
  };

  fetchData = async () => {
    const finalPrice = document.querySelector(".js-final-price");
    const configurationWrap = document.querySelector(".js-configuration");
    const selected = document.querySelectorAll(".js-configure-selected");
    const dims = document.querySelector(".js-dim-selected");
    const addToCart = document.querySelector(".js-configure-add-to-cart");
    const spinner = document.querySelector(".js-spinner");
    const finisher = document.querySelector(".js-finisher-selected");
    const selectedJSON = [];
    selected.forEach((item) => {
      let tax = item.getAttribute("data-tax");
      let value = item.getAttribute("data-slug");
      let id = item.getAttribute("data-id");
      let isChild = item.getAttribute("data-child");
      selectedJSON.push({ [tax]: value, id: id, is_child: isChild });
    });
    const formData = new FormData();
    formData.append("action", "single_product_variations");
    formData.append("data", JSON.stringify(selectedJSON));
    if (dims) {
      formData.append("dims", [
        dims.getAttribute("data-width") ?? "",
        dims.getAttribute("data-length") ?? "",
        dims.getAttribute("data-diameter") ?? "",
      ]);
    }
    if (finisher) {
      formData.append("finisher", finisher.innerText);
    }
    formData.append("prod_id", finalPrice.getAttribute("data-id"));
    spinner.classList.add("active");
    const response = await fetch(ajaxurl, {
      method: "POST",
      body: formData,
    });
    const data = await response.json();
    spinner.classList.remove("active");
    finalPrice.innerHTML = data.price;
    configurationWrap.innerHTML = data.configuration;
    addToCart.innerHTML = data.add_to_cart;
    new ProductConfigure();
  };

  addToCart = () => {
    const addToCartBtn = document.querySelector(".js-add-to-cart");
    if (!addToCartBtn) {
      return;
    }

    addToCartBtn.addEventListener("click", (e) => {
      e.preventDefault();
      const productID = addToCartBtn.dataset.productId;
      const variationID = addToCartBtn.dataset.variationId;
      const pickers = [];
      document
        .querySelectorAll(".js-picker-select-container")
        .forEach((item) => {
          pickers.push(item.getAttribute("data-title"));
        });

      const pickersFiltered = [...new Set(pickers)];
      const finisher = document.querySelector(".js-finisher-selected");

      if (!productID) return;

      let formData = new FormData();
      formData.append("action", "mrtn_add_to_cart");
      formData.append("product_id", productID);
      formData.append("variation_id", variationID);
      formData.append("pickers", pickersFiltered);
      if (finisher) {
        formData.append("finisher", finisher.innerText);
      }
      addToCartBtn.classList.add("disabled");
      fetch(ajaxurl, {
        method: "POST",
        body: formData,
      }).then((response) => {
        response
          .json()
          .then((data) => {
            if (data.success) {
              let headerCounter = document.querySelector(
                ".js-header-cart-count"
              );
              let miniCart = document.querySelector(
                ".widget_shopping_cart_content"
              );
              const messageDiv = document.querySelector(
                ".js-add-to-cart-message"
              );
              if (messageDiv) {
                messageDiv.classList.add("show");

                setTimeout(() => {
                  messageDiv.classList.remove("show");
                }, 3000);
              }

              if (headerCounter) {
                headerCounter.innerHTML = data.cart_contents_count;
              }

              miniCart.innerHTML = data.mini_cart_contents;
              new Cart();
            } else {
              //
            }
          })
          .catch((error) => console.log(error));
      });
    });
  };
}

export default ProductConfigure;
